import { render } from "./VabChartBar.vue?vue&type=template&id=ca53b5be"
import script from "./VabChartBar.vue?vue&type=script&lang=js"
export * from "./VabChartBar.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/echarts/components/VabChartBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca53b5be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca53b5be', __exports__)) {
    console.log('reload')
    api.reload('ca53b5be', __exports__)
  }
  
  module.hot.accept("./VabChartBar.vue?vue&type=template&id=ca53b5be", () => {
    console.log('re-render')
    api.rerender('ca53b5be', render)
  })

}


export default __exports__